import { render, staticRenderFns } from "./ScreenConfirmEmail.vue?vue&type=template&id=34e532c0&"
import script from "./ScreenConfirmEmail.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ScreenConfirmEmail.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e532c0')) {
      api.createRecord('34e532c0', component.options)
    } else {
      api.reload('34e532c0', component.options)
    }
    module.hot.accept("./ScreenConfirmEmail.vue?vue&type=template&id=34e532c0&", function () {
      api.rerender('34e532c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/ScreenConfirmEmail.vue"
export default component.exports